<template>
  <div class="app-container">
    <div class="common_dialog_box clearfix">
      <div class="common_title" style="font-weight:600">异常申报重试</div>
      <div class="item_one clearfix">
        <span style="font-weight:600;margin-right:15px">申报重试税额限制</span>
        <span style="color:gray">各异常申报税种低于上方设置的税额,才会进行异常申报重试</span>
        <el-form :inline="true" style="margin-top:20px" :model="ruleForm" :rules="rules">
          <el-form-item prop="zzs" label="增值税≤">
            <el-input v-model="zzs" type="text" size="mini" style="width:100px"></el-input>元
          </el-form-item>
          <el-form-item prop="sds" label="所得税≤">
            <el-input v-model="sds" type="text" size="mini" style="width:100px"></el-input>元
          </el-form-item>
          <el-form-item prop="qts" label="其他税≤">
            <el-input v-model="qts" type="text" size="mini" style="width:100px"></el-input>元
          </el-form-item>
          <el-form-item prop="yhs" label="印花税≤">
            <el-input v-model="yhs" type="text" size="mini" style="width:100px"></el-input>元
          </el-form-item>
          <el-form-item prop="fjs" label="附加税≤">
            <el-input v-model="fjs" type="text" size="mini" style="width:100px"></el-input>元
          </el-form-item>
        </el-form>
      </div>
      <div class="item_one clearfix">
        <span style="font-weight:600;margin-right:15px">定时重试</span>
        <span style="color:gray">请保证对应时间内,客户端和机柜开启</span>
        <el-form>
          <el-form-item>
            <el-checkbox v-model="checked" label="开启定时重试" size="large" />
          </el-form-item>
          <el-form-item>
            <div style="background-color:#eee;width:700px">
              <el-radio style="margin-left:20px" v-model="radio" label="1" size="large">默认时间:00:00-06:00</el-radio>
              <el-radio v-model="radio" label="2" size="large">
                自定义时间
                <el-time-picker
                    is-range
                    v-model="value1"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    placeholder="选择时间范围"
                    size="mini">
                  </el-time-picker>
              </el-radio>
            </div>
          </el-form-item>
        </el-form>
        
      </div>
    </div>
    <!-- 顶部表 -->
    <div class="common_dialog_box clearfix">
      <div class="common_title" style="font-weight:600">申报设置</div>
      <div class="item_one clearfix">
        <table class="content" cellspacing="0" width="100%" style="margin-top:30px">
          <tr class="top_bg">
            <td class="center" style="width:60%">状态及项目名称</td>
            <td class="center" style="width:40%">备注</td>
          </tr>
          <tr class="tr_height">
            <td style="width:60%">凡资产负债表期末资产总额为0，默认填写<el-input  type="number" v-model.number="info.zcfzMin" size="mini" style="width:150px;margin:0 10px" />元（默认借-货币资金、贷-其他应付款）<span  style="width:50%;color:red">（请填写0或者100以上的数字）</span></td>
            <td class="center" style="width:40%;color:red">应税务局要求从2020年第三季度开始，企业所得税申报表的资产总额必须和财务报表资产总额一致且不得为0。此项操作需人工操作，请谨慎修改金额！若由零申报改为税款申报，如需修改以前报表请自行去税局大厅处理。</td>
          </tr>

          <tr class="tr_height">
            <td style="width:60%">是否显示密码：
              <el-switch v-model="info.password" :active-value=1 :inactive-value=2></el-switch>
            </td>
            <td class="center" style="width:40%;color:red"></td>
          </tr>
          <tr class="tr_height">
            <td style="width:60%">凡所得税报表季初资产为0，默认填写<el-input  type="number" v-model.number="info.jczc" size="mini" style="width:150px;margin:0 10px" />元。季末资产为0，默认填写<el-input  type="number" v-model.number="info.jmzc" size="mini" style="width:150px;margin:0 10px" />元<span  style="width:50%;color:red">（请填写0或者100以上的数字）</span></td>
            <td style="width:40%">凡所得税报表季初从业人数为0，默认填写<el-input  type="number" v-model.number="info.jcrs" size="mini" style="width:150px;margin:0 10px" />人。季末从业人数为0，默认填写<el-input  type="number" v-model.number="info.jmrs" size="mini" style="width:150px;margin:0 10px" />人</td>
          </tr>
        </table>
      </div>
    </div>
    
    <div>
      <el-button @click="saveMin" type="success" size="mini" style="margin-top:20px;transform: translateY(-3px);">保存</el-button>
    </div>

  </div>
</template>

<script>
import { orgSettingInfo , orgSettingSave } from "@/api/org"
export default {
  name: "org-setting",
  data() {
    return {
      contentStyleObj:{}, //高度变化
      info:{
        zcfzMin: 0,
        password: 2,
        jczc: 2,
        jmzc: 2,
        jcrs: 2,
        jmrs: 2,
      },
      checked:true,
      radio:'1',
      value1: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
      ruleForm: {
        zzs: '',
        sds: '',
        qts: '',
        yhs: '',
        fjs: '',
      },
      rules: {
        zzs: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        sds: [
          { required: true, message: '请选择活动区域', trigger: 'change' }
        ],
        qts: [
          { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
        ],
        yhs: [
          { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
        ],
        fjs: [
          { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    // 获取表格高度
    this.contentStyleObj=this.$getHeight(186)
    this.getList();
  },
  methods:{
    getList(){
      this.listLoading = true;
      orgSettingInfo({}).then(res => {
        let info = res.data.data
        if(info.password == 0){
          info.password = 2
        }
        this.info = info
        this.listLoading = false;
      })
    },
    saveMin(){
      this.info.zcfzMin = Number(this.info.zcfzMin);
      this.info.jczc = Number(this.info.jczc);
      this.info.jmzc = Number(this.info.jmzc);
      this.info.jcrs = Number(this.info.jcrs);
      this.info.jmrs = Number(this.info.jmrs);
      orgSettingSave(this.info).then(res=>{
        if(res.data.msg == 'success'){
          this.$message({
            message: '设置成功',
            type: 'success'
          });
           this.getList()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container{
  font-size: 14px;
}
.tr_height td{
  padding: 5px 10px !important;
}

.center{
  text-align: center;
}
.content{
  // width: 2000px;
  width: 100%;
  margin: 0 auto;
  border:1px solid #c2c2c2;
  border-bottom: none;
  border-right: none;
  margin-top: 10px;
  .top_bg{
    td{
      font-size: 14px !important;
    }
    
  }
  span{
    line-height: 34px;
    font-size: 14px;
  }
  tr{
    padding: 0;
    margin: 0;
  }
  
  td{
    border-right:1px solid #c2c2c2;
    border-bottom:1px solid #c2c2c2;
    line-height: 26px;
    padding:0 6px;
    color: #333;
    font-size: 14px;

  }
  input{
    width: 100%;
    line-height: 34px;
    // padding: 0 6px;
    text-align: right;
    font-size: 14px;
  }
}
</style>
